<template>
  <div class="wrapper-setting">
    <div class="col">
      <el-row>
        <el-col :span="5">
          <div class="bg-white min-height">
            <home-sidebar active_item="setting"></home-sidebar>
          </div>
        </el-col>
        <el-col :span="19">
          <div class="bg-white min-height ml-3">
            <div class="pt-3">
              <el-form ref="userForm" :model="userForm" status-icon :rules="rules" label-width="100px">
                <el-form-item label="用户名">
                  <el-input v-model="userForm.name" :disabled="true" class="item_w"></el-input>
                </el-form-item>
                <el-form-item label="邮箱" prop="email">
                  <el-input v-model="userForm.email" class="item_w"></el-input>
                </el-form-item>
                <el-form-item label="电话号码" prop="phone">
                  <el-input v-model="userForm.phone" class="item_w"></el-input>
                </el-form-item>
                <el-form-item label="出生日期">
                  <el-date-picker type="date" placeholder="选择日期" v-model="userForm.birthday"
                                  class="item_w"></el-date-picker>
                </el-form-item>
                <el-form-item label="性别">
                  <template slot-scope="scope">
                    <el-radio-group v-model="userForm.sex">
                      <el-radio label=1>男</el-radio>
                      <el-radio label=0>女</el-radio>
                    </el-radio-group>
                  </template>
                </el-form-item>
                <el-form-item label="通讯地址">
                  <el-input type="textarea" v-model="userForm.address" class="item_w1"></el-input>
                </el-form-item>
                <el-form-item>
                  <el-button type="primary" :loading="addLoading" @click="submitForm">确定修改
                  </el-button>
                </el-form-item>
              </el-form>
            </div>
          </div>
        </el-col>
      </el-row>
    </div>
  </div>
</template>

<script>
import api from '../../api/rest'
import util from '../../api/util'
import HomeSidebar from "../../components/HomeSidebar.vue";

export default {
  components: {HomeSidebar},
  data() {
    return {
      user: '',
      dlg_change_pass: false,
      dlg_upload_img: false,
      form: {},
      addLoading: false,
      pickerOptions: util.setting.getPickeAgeOpt(),
      provs: util.setting.getProvs(),
      degreeList: util.setting.getDegree(),
      rules: util.setting.getRules(),
      userForm: {
        id: '',
        name: '',
        email: '',
        birthday: '',
        phone: '',
        sex: '',
        address: ''
      },
    }
  },
  methods: {
    handleClose(tagList, tag) {
      tagList.splice(tagList.indexOf(tag), 1);
    },

    update_entInfo() {
      let api_url = '/group/updateEntInfo'
      let data = this.form
      api.remote.doPost(data, api_url).then((res) => {
        this.$message({
          title: res.title,
          message: res.message,
          type: res.status
        })
      })
    },

    submitForm() {
      this.$refs.userForm.validate((valid) => {
        if (valid) {
          this.addLoading = true
          let para = Object.assign({}, this.userForm)
          api.admin.updateUserInfo(para).then((res) => {
            this.addLoading = false
            this.$message({
              title: res.title,
              message: res.message,
              type: res.status
            })
          }).catch((res) => {
            this.addLoading = false
            api.handError.action(this, res)
          })
        }
      });
    },
    resetForm() {
      this.$refs.userForm.resetFields()
    },
    validatePass2(rule, value, callback) {
      if (value !== this.changeForm.painpwd) {
        callback(new Error('两次输入密码不一致!'))
      } else {
        callback()
      }
    },
    fill_group(groupId) {
      let api_url = '/group/getById'
      let data = {
        id: groupId
      }
      api.remote.doPost(data, api_url).then((res) => {
        this.form = res
        if (this.form.cusTags == null) {
          this.form.cusTags = ['测试标签']
        }
        if (this.form.fapiaoTags == null) {
          this.form.fapiaoTags = ['测试标签']
        }
        if (this.form.contractTags == null) {
          this.form.contractTags = ['测试标签']
        }
      })
    }
  },

  mounted() {
    var user = api.storage.get('user')
    if (user != null) {
      api.admin.get_user_by_name(user.userName).then((res) => {
        this.userForm = res
        this.fill_group(res.groupId)
        this.addLoading = false
      }).catch((res) => {
        this.addLoading = false
        api.handError.action(this, res)
      })
    }
  }
}
</script>


// WEBPACK FOOTER //
// Setting.vue?3bd35a3e